import { apiRTK as api } from "./src/apiRTK";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMcbimSpaces: build.query<
      GetMcbimSpacesApiResponse,
      GetMcbimSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces`,
        params: {
          projectNo: queryArg.projectNo,
          jobId: queryArg.jobId,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    getMcbimSpacesInProject: build.query<
      GetMcbimSpacesInProjectApiResponse,
      GetMcbimSpacesInProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces.in.project`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimItem: build.query<GetMcbimItemApiResponse, GetMcbimItemApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/item`,
        params: {
          projectNo: queryArg.projectNo,
          itemId: queryArg.itemId,
        },
      }),
    }),
    getMcbimItemsInSpace: build.query<
      GetMcbimItemsInSpaceApiResponse,
      GetMcbimItemsInSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items.in.space`,
        params: {
          spaceId: queryArg.spaceId,
          spaceName: queryArg.spaceName,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFileFloorVersions: build.query<
      GetMcbimFileFloorVersionsApiResponse,
      GetMcbimFileFloorVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/file.floor.versions`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimSingleMcbimSpace: build.query<
      GetMcbimSingleMcbimSpaceApiResponse,
      GetMcbimSingleMcbimSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/single-mcbim-space`,
        params: {
          projectNo: queryArg.projectNo,
          name: queryArg.name,
        },
      }),
    }),
    postMcbimItems: build.query<
      PostMcbimItemsApiResponse,
      PostMcbimItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMcbimBuildingStories: build.query<
      GetMcbimBuildingStoriesApiResponse,
      GetMcbimBuildingStoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/building-stories`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMcbimTrendByKey: build.query<
      PostMcbimTrendByKeyApiResponse,
      PostMcbimTrendByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/trend-by-key`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRooms: build.query<
      PostMultiplacerRoomsApiResponse,
      PostMultiplacerRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerSingleRoom: build.query<
      GetMultiplacerSingleRoomApiResponse,
      GetMultiplacerSingleRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/single-room`,
        params: {
          roomNumber: queryArg.roomNumber,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMultiplacerStandardRooms: build.query<
      GetMultiplacerStandardRoomsApiResponse,
      GetMultiplacerStandardRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/standard-rooms`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    putMultiplacerRoomLock: build.mutation<
      PutMultiplacerRoomLockApiResponse,
      PutMultiplacerRoomLockApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/lock`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeiling: build.mutation<
      PostMultiplacerRoomCeilingApiResponse,
      PostMultiplacerRoomCeilingApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerAirflowsImport: build.mutation<
      PostMultiplacerAirflowsImportApiResponse,
      PostMultiplacerAirflowsImportApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/airflows/import`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomValidation: build.mutation<
      DeleteMultiplacerRoomValidationApiResponse,
      DeleteMultiplacerRoomValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerRoomMlPredictions: build.mutation<
      PostMultiplacerRoomMlPredictionsApiResponse,
      PostMultiplacerRoomMlPredictionsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ml-predictions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionStatus: build.mutation<
      PostMultiplacerRoomValidationDecisionStatusApiResponse,
      PostMultiplacerRoomValidationDecisionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/status`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionComment: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentApiResponse,
      PostMultiplacerRoomValidationDecisionCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentUpdate: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse,
      PostMultiplacerRoomValidationDecisionCommentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentDelete: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse,
      PostMultiplacerRoomValidationDecisionCommentDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomSnapshotTrendByKey: build.query<
      PostMultiplacerRoomSnapshotTrendByKeyApiResponse,
      PostMultiplacerRoomSnapshotTrendByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room-snapshot/trend-by-key`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevices: build.query<
      PostMultiplacerDevicesApiResponse,
      PostMultiplacerDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerDeviceUpdate: build.mutation<
      PutMultiplacerDeviceUpdateApiResponse,
      PutMultiplacerDeviceUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDeviceAddDevices: build.mutation<
      PostMultiplacerDeviceAddDevicesApiResponse,
      PostMultiplacerDeviceAddDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/add-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDeviceDeleteInRooms: build.mutation<
      PostMultiplacerDeviceDeleteInRoomsApiResponse,
      PostMultiplacerDeviceDeleteInRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-in-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerDeviceDeleteDevice: build.mutation<
      DeleteMultiplacerDeviceDeleteDeviceApiResponse,
      DeleteMultiplacerDeviceDeleteDeviceApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-device`,
        method: "DELETE",
        params: {
          deviceId: queryArg.deviceId,
        },
      }),
    }),
    getAuthMe: build.query<GetAuthMeApiResponse, GetAuthMeApiArg>({
      query: () => ({ url: `/auth/me` }),
    }),
    getProjectSyncRuns: build.query<
      GetProjectSyncRunsApiResponse,
      GetProjectSyncRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/sync-runs`,
        params: {
          projectNo: queryArg.projectNo,
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    postTdroomUpsert: build.mutation<
      PostTdroomUpsertApiResponse,
      PostTdroomUpsertApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/upsert`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTdroomSingle: build.query<
      GetTdroomSingleApiResponse,
      GetTdroomSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/single`,
        params: {
          tdroomId: queryArg.tdroomId,
        },
      }),
    }),
    getTdroomAll: build.query<GetTdroomAllApiResponse, GetTdroomAllApiArg>({
      query: () => ({ url: `/tdroom/all` }),
    }),
    postAddProjectTdRooms: build.mutation<
      PostAddProjectTdRoomsApiResponse,
      PostAddProjectTdRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/add-project-td-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypes: build.query<
      GetMultiplacerDevicetypesApiResponse,
      GetMultiplacerDevicetypesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerDevicetypesAggregate: build.mutation<
      PostMultiplacerDevicetypesAggregateApiResponse,
      PostMultiplacerDevicetypesAggregateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.aggregate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypesStats: build.query<
      GetMultiplacerDevicetypesStatsApiResponse,
      GetMultiplacerDevicetypesStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.stats`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMlPredictCeilingDevices: build.mutation<
      PostMlPredictCeilingDevicesApiResponse,
      PostMlPredictCeilingDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/ml/predict-ceiling-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMlPing: build.query<GetMlPingApiResponse, GetMlPingApiArg>({
      query: () => ({ url: `/ml/ping` }),
    }),
    postMultiplacerProjectAddProject: build.mutation<
      PostMultiplacerProjectAddProjectApiResponse,
      PostMultiplacerProjectAddProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/add-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjects: build.query<
      GetMultiplacerProjectsApiResponse,
      GetMultiplacerProjectsApiArg
    >({
      query: () => ({ url: `/multiplacer/projects` }),
    }),
    postProjectDrofusUpdateSettings: build.mutation<
      PostProjectDrofusUpdateSettingsApiResponse,
      PostProjectDrofusUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjectsSingleProject: build.query<
      GetMultiplacerProjectsSingleProjectApiResponse,
      GetMultiplacerProjectsSingleProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/single-project`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerProjectEditProject: build.mutation<
      PostMultiplacerProjectEditProjectApiResponse,
      PostMultiplacerProjectEditProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/edit-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectVentilationUpdateSettings: build.mutation<
      PostProjectVentilationUpdateSettingsApiResponse,
      PostProjectVentilationUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/ventilation.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    ping: build.query<PingApiResponse, PingApiArg>({
      query: () => ({ url: `/ping` }),
    }),
    getFunctionsPing: build.query<
      GetFunctionsPingApiResponse,
      GetFunctionsPingApiArg
    >({
      query: () => ({ url: `/functions/ping` }),
    }),
    postMultiplacerEnrichRoom: build.mutation<
      PostMultiplacerEnrichRoomApiResponse,
      PostMultiplacerEnrichRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/enrich-room`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerSyncStart: build.mutation<
      PostMultiplacerSyncStartApiResponse,
      PostMultiplacerSyncStartApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/sync/start`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectDrofusVerifyConnection: build.mutation<
      PostProjectDrofusVerifyConnectionApiResponse,
      PostProjectDrofusVerifyConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.verify-connection`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as openapi };
export type GetMcbimSpacesApiResponse = /** status 200 Successful response */ {
  _id?: string | any;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  fileName: string;
  globalId: string;
  longName?: string;
  name: string;
  polygon?: number[][];
}[];
export type GetMcbimSpacesApiArg = {
  projectNo: number;
  jobId: string;
  floorGlobalId?: string;
};
export type GetMcbimSpacesInProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    name: string;
    globalId: string;
    longName?: string;
  }[];
export type GetMcbimSpacesInProjectApiArg = {
  projectNo: number;
};
export type GetMcbimItemApiResponse = /** status 200 Successful response */ {
  _id?: string | any;
  globalId: string;
  bbox?: number[][];
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  centerPoint?: number[];
  fileAttr1?: string;
  fileAttr2?: string;
  fileAttr3?: string;
  fileAttr4?: string;
  fileIfcSchema: string;
  fileIsLatest: boolean;
  fileLastModifiedBy: string;
  fileName: string;
  filePath: string;
  fileStorageId: string;
  fileUploadedAt: string;
  includedMaterials?: {
    [key: string]: boolean;
  };
  insertedAt: string;
  instanceClass: string;
  longName?: string;
  materials?: {
    [key: string]: number;
  }[];
  name: string;
  job: {
    jobId?: any;
    createdAt: string;
  };
  polygon?: number[][];
  psets: {
    [key: string]: {
      [key: string]: (string | number) | boolean;
    };
  };
  type: {
    globalId: string;
    name: string;
    typeClass: string;
  } | null;
  searchHit?: boolean;
  fillColor?: string;
  area?: string;
  deviceCategory?:
    | (
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW"
        | null
      )
    | null;
  ceilingGrid?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
  };
} | null;
export type GetMcbimItemApiArg = {
  projectNo: number;
  itemId: string;
};
export type GetMcbimItemsInSpaceApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    globalId: string;
    bbox?: number[][];
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    centerPoint?: number[];
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    instanceClass: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    job: {
      jobId?: any;
      createdAt: string;
    };
    polygon?: number[][];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
    } | null;
    searchHit?: boolean;
    fillColor?: string;
    area?: string;
    deviceCategory?:
      | (
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW"
          | null
        )
      | null;
    ceilingGrid?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
    };
  }[];
export type GetMcbimItemsInSpaceApiArg = {
  spaceId?: string;
  spaceName?: string;
  projectNo: number;
};
export type GetMcbimFileFloorVersionsApiResponse =
  /** status 200 Successful response */ {
    buildingStoryName: string;
    buildingStoryGlobalId: string;
    jobId: string;
    createdAt: string;
    fileName: string;
  }[];
export type GetMcbimFileFloorVersionsApiArg = {
  projectNo: number;
};
export type GetMcbimSingleMcbimSpaceApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    globalId: string;
    bbox?: number[][];
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    centerPoint?: number[];
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    instanceClass: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    job: {
      jobId?: any;
      createdAt: string;
    };
    polygon?: number[][];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
    } | null;
    searchHit?: boolean;
    fillColor?: string;
    area?: string;
    deviceCategory?:
      | (
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW"
          | null
        )
      | null;
    ceilingGrid?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
    };
  } | null;
export type GetMcbimSingleMcbimSpaceApiArg = {
  projectNo: number;
  name: string;
};
export type PostMcbimItemsApiResponse = /** status 200 Successful response */ {
  _id?: string | any;
  name: string;
  longName?: string;
  globalId: string;
  polygon?: number[][];
  bbox?: number[][];
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  fileName: string;
  instanceClass: string;
}[];
export type PostMcbimItemsApiArg = {
  body: {
    projectNo: number;
    buildingStoryName: string;
    instanceClasses: string[];
  };
};
export type GetMcbimBuildingStoriesApiResponse =
  /** status 200 Successful response */ {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
    spaceCount: number;
    job: {
      jobId?: any;
      createdAt: string;
    };
  }[];
export type GetMcbimBuildingStoriesApiArg = {
  projectNo: number;
};
export type PostMcbimTrendByKeyApiResponse =
  /** status 200 Successful response */ {
    date: string;
    series: {
      value?: any;
      count: number;
    }[];
    total: number;
  }[];
export type PostMcbimTrendByKeyApiArg = {
  body: {
    projectNo: number;
    keyPath: string;
    filter: {
      instanceClasses?: string[];
      names?: string[];
      dateFrom: string;
      dateTo: string;
    };
    granularity?: "day" | "week" | "month";
    excludeEmptyString?: boolean;
    includeOther?: boolean;
  };
};
export type PostMultiplacerRoomsApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomName?: string;
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      ceilingCoordinate?: number[];
      ceilingDirection?: number[];
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id: string;
          name: string;
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
          };
        };
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              updatedByUserName: string;
              updatedAt: string;
            };
          };
        };
      };
    };
  };
export type PostMultiplacerRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers?: string[];
  };
};
export type GetMultiplacerSingleRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  } | null;
export type GetMultiplacerSingleRoomApiArg = {
  roomNumber: string;
  projectNo: number;
};
export type GetMultiplacerStandardRoomsApiResponse =
  /** status 200 Successful response */ string[];
export type GetMultiplacerStandardRoomsApiArg = {
  projectNo: number;
};
export type PutMultiplacerRoomLockApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PutMultiplacerRoomLockApiArg = {
  body: {
    roomNumber: string;
    lock: boolean;
    projectNo: number;
  };
};
export type PostMultiplacerRoomCeilingApiResponse =
  /** status 200 Successful response */ {
    matchedCount: number;
    modifiedCount: number;
    upsertedCount: number;
    upsertedIds: string[];
  };
export type PostMultiplacerRoomCeilingApiArg = {
  body: {
    projectNo: number;
    rooms: {
      roomNumber: string;
      ceilingCoordinate?: number[];
      ceilingDirection?: number[];
    }[];
  };
};
export type PostMultiplacerAirflowsImportApiResponse =
  /** status 200 Successful response */ {
    counts: {
      received: number;
      deduplicated: number;
      matched: number;
      updated: number;
      unchanged: number;
      unknown: number;
    };
    unknownRooms: string[];
  };
export type PostMultiplacerAirflowsImportApiArg = {
  body: {
    projectNo: number;
    items: {
      roomNumber: string;
      supplyAirFlow: number;
      returnAirFlow: number;
    }[];
    dryRun?: boolean;
  };
};
export type DeleteMultiplacerRoomValidationApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type DeleteMultiplacerRoomValidationApiArg = {
  projectNo: number;
};
export type PostMultiplacerRoomMlPredictionsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PostMultiplacerRoomMlPredictionsApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    predictions: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
  };
};
export type PostMultiplacerRoomValidationDecisionStatusApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PostMultiplacerRoomValidationDecisionStatusApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
    comment?: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
  };
};
export type PostMultiplacerRoomSnapshotTrendByKeyApiResponse =
  /** status 200 Successful response */ {
    date: string;
    series: {
      value?: any;
      count: number;
    }[];
    total: number;
  }[];
export type PostMultiplacerRoomSnapshotTrendByKeyApiArg = {
  body: {
    projectNo: number;
    keyPath:
      | (
          | "supplyAirFlow"
          | "returnAirFlow"
          | "drStatus"
          | "extraIfcInfo.mmi"
          | "rfpStatus"
          | "rfpMalRom"
        )
      | string;
    filter: {
      roomNumbers?: string[];
      dateFrom: string;
      dateTo: string;
    };
    granularity?: "day" | "week" | "month";
    excludeEmptyString?: boolean;
    bucketConfig?:
      | {
          kind: "none";
        }
      | {
          kind: "ranges";
          ranges: {
            id: string;
            min: number;
            max: number;
          }[];
        };
  };
};
export type PostMultiplacerDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    revitCeilingHeight?: number;
    roomNumber: string;
    supplyAirFlow?: number;
    updatedAt?: string;
  }[];
export type PostMultiplacerDevicesApiArg = {
  body: {
    floor?: string;
    projectNo: number;
    roomNumbers?: string[];
  };
};
export type PutMultiplacerDeviceUpdateApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    revitCeilingHeight?: number;
    roomNumber: string;
    supplyAirFlow?: number;
    updatedAt?: string;
  };
export type PutMultiplacerDeviceUpdateApiArg = {
  body: {
    device: {
      _id?: string | any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      revitCeilingHeight?: number;
      roomNumber: string;
      supplyAirFlow?: number;
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerDeviceAddDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    revitCeilingHeight?: number;
    roomNumber: string;
    supplyAirFlow?: number;
    updatedAt?: string;
  }[];
export type PostMultiplacerDeviceAddDevicesApiArg = {
  body: {
    devices: {
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      revitCeilingHeight?: number;
      roomNumber: string;
      supplyAirFlow?: number;
    }[];
  };
};
export type PostMultiplacerDeviceDeleteInRoomsApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type PostMultiplacerDeviceDeleteInRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type DeleteMultiplacerDeviceDeleteDeviceApiResponse =
  /** status 200 Successful response */ {
    acknowledged: boolean;
    deletedCount: number;
  };
export type DeleteMultiplacerDeviceDeleteDeviceApiArg = {
  deviceId: string;
};
export type GetAuthMeApiResponse = /** status 200 Successful response */ {
  _id: string;
  displayName: string;
  email?: string;
};
export type GetAuthMeApiArg = void;
export type GetProjectSyncRunsApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      type: "syncPipeline";
      trigger: "manual" | "scheduled" | "queue";
      requestedBy?: string;
      correlationId?: string;
      status: "running" | "succeeded" | "failed" | "canceled";
      createdAt: string;
      startedAt?: string;
      finishedAt?: string;
      elapsedMs?: number;
      steps: {
        roomsSync?: {
          status: "pending" | "running" | "succeeded" | "failed" | "skipped";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            stats: {
              rfpFetched: number;
              rfpFetchFailed: boolean;
              ifcSpacesFetched: number;
              uniqueRoomNumbers: number;
              flagsResetRoomsMatched: number;
              upsertOps: number;
            };
          };
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string;
            message: string;
            stack?: string;
          };
        };
        specifiedArticlesSync?: {
          status: "running" | "succeeded" | "failed" | "pending";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            fetchedRows: number;
            uniqueRoomNumbers: number;
            resetMatchedRooms: number;
            bulkOps: number;
          };
          error?: {
            origin: string;
            code?: string | null;
            message?: string | null;
            stack?: string | null;
          } | null;
        };
        enqueueEnrich?: {
          status: "pending" | "running" | "succeeded" | "failed" | "skipped";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          jobTypes?: ("addIfcInfo" | "mlPredictDevices" | string)[];
          queuedBatches?: number;
          totalRooms?: number;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string;
            message: string;
            stack?: string;
          };
        };
        enrich?: {
          status: "pending" | "running" | "succeeded" | "failed" | "skipped";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          total?: number;
          done?: number;
          failed?: number;
          lastUpdatedAt?: string;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string;
            message: string;
            stack?: string;
          };
        };
      };
      meta?: {
        functionName?: string;
        invocationId?: string;
        hostInstanceId?: string;
        env?: string;
        version?: string;
      };
    }[];
    nextCursor?: string;
  };
export type GetProjectSyncRunsApiArg = {
  projectNo: number;
  limit?: number;
  cursor?: string;
};
export type PostTdroomUpsertApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: string | any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      revitCeilingHeight?: number;
      roomNumber: string;
      supplyAirFlow?: number;
      updatedAt?: string;
    }[];
  } | null;
export type PostTdroomUpsertApiArg = {
  body: {
    _id?: string | any;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: string | any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      revitCeilingHeight?: number;
      roomNumber: string;
      supplyAirFlow?: number;
      updatedAt?: string;
    }[];
  };
};
export type GetTdroomSingleApiResponse = /** status 200 Successful response */ {
  _id?: string | any;
  projectNo: number;
  roomNumber: string;
  roomLongName: string;
  area: number;
  polygon: number[][];
  devices: {
    _id?: string | any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction?: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    revitCeilingHeight?: number;
    roomNumber: string;
    supplyAirFlow?: number;
    updatedAt?: string;
  }[];
} | null;
export type GetTdroomSingleApiArg = {
  tdroomId: string;
};
export type GetTdroomAllApiResponse = /** status 200 Successful response */ {
  _id?: string | any;
  roomLongName: string;
  roomNumber: string;
  projectNo: number;
}[];
export type GetTdroomAllApiArg = void;
export type PostAddProjectTdRoomsApiResponse =
  /** status 200 Successful response */ {
    nrOfRoomsAdded: number;
  };
export type PostAddProjectTdRoomsApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id?: string | any;
      globalId: string;
      bbox?: number[][];
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      centerPoint?: number[];
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      instanceClass: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      job: {
        jobId?: any;
        createdAt: string;
      };
      polygon?: number[][];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
      } | null;
      searchHit?: boolean;
      fillColor?: string;
      area?: string;
      deviceCategory?:
        | (
            | "CHILLER_DEVICE"
            | "DEFAULT_DEVICE"
            | "DOOR"
            | "DOWN_LIGHT_DEVICE"
            | "FIRE_SUPPRESSION_DEVICE"
            | "FURNITURE"
            | "LIGHT_DEVICE_CIRCULAR"
            | "LIGHT_DEVICE"
            | "RETURN_AIR_DEVICE"
            | "SENSOR_DEVICE"
            | "SUPPLY_AIR_DEVICE"
            | "WINDOW"
            | null
          )
        | null;
      ceilingGrid?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
      };
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type GetMultiplacerDevicetypesApiArg = {
  projectNo: number;
};
export type PostMultiplacerDevicetypesAggregateApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id?: string | any;
      globalId: string;
      bbox?: number[][];
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      centerPoint?: number[];
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      instanceClass: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      job: {
        jobId?: any;
        createdAt: string;
      };
      polygon?: number[][];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
      } | null;
      searchHit?: boolean;
      fillColor?: string;
      area?: string;
      deviceCategory?:
        | (
            | "CHILLER_DEVICE"
            | "DEFAULT_DEVICE"
            | "DOOR"
            | "DOWN_LIGHT_DEVICE"
            | "FIRE_SUPPRESSION_DEVICE"
            | "FURNITURE"
            | "LIGHT_DEVICE_CIRCULAR"
            | "LIGHT_DEVICE"
            | "RETURN_AIR_DEVICE"
            | "SENSOR_DEVICE"
            | "SUPPLY_AIR_DEVICE"
            | "WINDOW"
            | null
          )
        | null;
      ceilingGrid?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
      };
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type PostMultiplacerDevicetypesAggregateApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesStatsApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    total: number;
    categories: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      count: number;
    }[];
  };
export type GetMultiplacerDevicetypesStatsApiArg = {
  projectNo: number;
};
export type PostMlPredictCeilingDevicesApiResponse =
  /** status 200 Successful response */ {
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    coordinate: number[];
  }[];
export type PostMlPredictCeilingDevicesApiArg = {
  body: {
    roomNr: string;
    projectNo: number;
  };
};
export type GetMlPingApiResponse = /** status 200 Successful response */ {
  message: string;
};
export type GetMlPingApiArg = void;
export type PostMultiplacerProjectAddProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    title: string;
    compCodePath: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
  };
export type PostMultiplacerProjectAddProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      pnsPath?: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
      enrich?: {
        status: "idle" | "running" | "done";
        total: number;
        done: number;
        failed?: number;
        startedAt?: string | null;
        finishedAt?: string | null;
      };
      ventilation?: {
        compCodeDirectionRules?: {
          prefix: string;
          direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
          description?: string;
        }[];
        updatedAt?: string;
      };
      drofus?: {
        drofusBaseUrl: string;
        drofusDb: string;
        drofusProject: string;
        hasApiKey: boolean;
        last4?: string;
        verifiedAt?: string;
        updatedAt?: string;
      };
    };
  };
};
export type GetMultiplacerProjectsApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    title: string;
    compCodePath: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
  }[];
export type GetMultiplacerProjectsApiArg = void;
export type PostProjectDrofusUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    drofusBaseUrl: string;
    drofusDb: string;
    drofusProject: string;
    hasApiKey: boolean;
    last4?: string;
    verifiedAt?: string;
    updatedAt?: string;
  };
export type PostProjectDrofusUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    settings: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      apiKey?: string;
    };
  };
};
export type GetMultiplacerProjectsSingleProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    title: string;
    compCodePath: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
  };
export type GetMultiplacerProjectsSingleProjectApiArg = {
  projectNo: number;
};
export type PostMultiplacerProjectEditProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: string | any;
    projectNo: number;
    title: string;
    compCodePath: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
  };
export type PostMultiplacerProjectEditProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
      enrich?: {
        status: "idle" | "running" | "done";
        total: number;
        done: number;
        failed?: number;
        startedAt?: string | null;
        finishedAt?: string | null;
      };
      ventilation?: {
        compCodeDirectionRules?: {
          prefix: string;
          direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
          description?: string;
        }[];
        updatedAt?: string;
      };
      drofus?: {
        drofusBaseUrl: string;
        drofusDb: string;
        drofusProject: string;
        hasApiKey: boolean;
        last4?: string;
        verifiedAt?: string;
        updatedAt?: string;
      };
    };
  };
};
export type PostProjectVentilationUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    compCodeDirectionRules: {
      prefix: string;
      direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
      description?: string;
    }[];
    updatedAt?: string;
  };
export type PostProjectVentilationUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    ventilation: {
      compCodeDirectionRules?: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
  };
};
export type PingApiResponse = /** status 200 Successful response */ {
  ping: string;
};
export type PingApiArg = void;
export type GetFunctionsPingApiResponse =
  /** status 200 Successful response */ any;
export type GetFunctionsPingApiArg = void;
export type PostMultiplacerEnrichRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomName?: string;
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    pns?: string | null;
    ceilingCoordinate?: number[];
    ceilingDirection?: number[];
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          sources: {
            mcbimFileId?: string;
            storyCode?: string;
          };
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id?: any;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt: string;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
  } | null;
export type PostMultiplacerEnrichRoomApiArg = {
  body: {
    projectNo: number;
    roomNr: string;
    jobTypes: ("addIfcInfo" | "mlPredictDevices" | string)[];
    dryRun?: boolean;
  };
};
export type PostMultiplacerSyncStartApiResponse =
  /** status 200 Successful response */ {
    queuedBatches: number;
    totalRooms: number;
  };
export type PostMultiplacerSyncStartApiArg = {
  body: {
    projectNo: number;
    jobTypes: ("addIfcInfo" | "mlPredictDevices" | string)[];
  };
};
export type PostProjectDrofusVerifyConnectionApiResponse =
  /** status 200 Successful response */
    | {
        ok: true;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs: number;
      }
    | {
        ok: false;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs?: number;
        error: {
          origin: "upstream" | "config" | "network" | "unknown";
          httpStatus?: number;
          code?: string;
          message: string;
        };
      };
export type PostProjectDrofusVerifyConnectionApiArg = {
  body: {
    projectNo: number;
  };
};
export type Error = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error2 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error3 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error4 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error5 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export const {
  useGetMcbimSpacesQuery,
  useGetMcbimSpacesInProjectQuery,
  useGetMcbimItemQuery,
  useGetMcbimItemsInSpaceQuery,
  useGetMcbimFileFloorVersionsQuery,
  useGetMcbimSingleMcbimSpaceQuery,
  usePostMcbimItemsQuery,
  useGetMcbimBuildingStoriesQuery,
  usePostMcbimTrendByKeyQuery,
  usePostMultiplacerRoomsQuery,
  useGetMultiplacerSingleRoomQuery,
  useGetMultiplacerStandardRoomsQuery,
  usePutMultiplacerRoomLockMutation,
  usePostMultiplacerRoomCeilingMutation,
  usePostMultiplacerAirflowsImportMutation,
  useDeleteMultiplacerRoomValidationMutation,
  usePostMultiplacerRoomMlPredictionsMutation,
  usePostMultiplacerRoomValidationDecisionStatusMutation,
  usePostMultiplacerRoomValidationDecisionCommentMutation,
  usePostMultiplacerRoomValidationDecisionCommentUpdateMutation,
  usePostMultiplacerRoomValidationDecisionCommentDeleteMutation,
  usePostMultiplacerRoomSnapshotTrendByKeyQuery,
  usePostMultiplacerDevicesQuery,
  usePutMultiplacerDeviceUpdateMutation,
  usePostMultiplacerDeviceAddDevicesMutation,
  usePostMultiplacerDeviceDeleteInRoomsMutation,
  useDeleteMultiplacerDeviceDeleteDeviceMutation,
  useGetAuthMeQuery,
  useGetProjectSyncRunsQuery,
  usePostTdroomUpsertMutation,
  useGetTdroomSingleQuery,
  useGetTdroomAllQuery,
  usePostAddProjectTdRoomsMutation,
  useGetMultiplacerDevicetypesQuery,
  usePostMultiplacerDevicetypesAggregateMutation,
  useGetMultiplacerDevicetypesStatsQuery,
  usePostMlPredictCeilingDevicesMutation,
  useGetMlPingQuery,
  usePostMultiplacerProjectAddProjectMutation,
  useGetMultiplacerProjectsQuery,
  usePostProjectDrofusUpdateSettingsMutation,
  useGetMultiplacerProjectsSingleProjectQuery,
  usePostMultiplacerProjectEditProjectMutation,
  usePostProjectVentilationUpdateSettingsMutation,
  usePingQuery,
  useGetFunctionsPingQuery,
  usePostMultiplacerEnrichRoomMutation,
  usePostMultiplacerSyncStartMutation,
  usePostProjectDrofusVerifyConnectionMutation,
} = injectedRtkApi;
